import React from 'react';
import { getPatientPresignedUrl } from '../../Apis/Patient';
import UppyDashboard from '@a2d24/uppy';

const FileUploader = (props) => {
    const maxFileSize = 5
    const onAfterUpload = async (file, plugin) => {
        plugin.uppy.emit('postprocess-progress', file, {
            mode: 'indeterminate',
            message: 'Adding metadata',
        });
        plugin.uppy.setFileState(file.id, {
            meta: {
                ...file.meta,
            },
        });
    };

    return (
        <UppyDashboard
            s3PreSignAdapter={(file) => {
                return getPatientPresignedUrl(
                    `${props.patient_identifier}/${props.booking_id}`,
                    file.type,
                    file.extension
                );
            }}
            plugins={[]}
            height="calc(85vh - 375px)"
            width={'100%'}
            onAfterUpload={onAfterUpload}
            showRemoveButtonAfterComplete={true}
            enableWebcam={false}
            options={{
                autoProceed: true,
                hideAfterFinish: true,
                restrictions: {
                    maxFileSize: maxFileSize * 1024 * 1024,
                    allowedFileTypes: ['image/*', 'application/pdf'],
                    maxNumberOfFiles: 1,
                },
            }}
            hideProgressAfterFinish={true}
            maxFileSize={maxFileSize}
        />
    );
};

export default FileUploader;
